<style scoped>
</style>
<template>
  <div>
    <!-- <div>{{phone}}{{hezuo}}{{this.info.name}}{{this.info.phone2}}{{this.info.ID}}{{this.info.email}}{{this.info.ads}}{{this.info.pingtainame}}{{this.info.pingtaiID}}{{this.info.minelink}}{{this.info.radio1}}{{this.info.radio2}}{{this.info.keyurl}}</div> -->
    <!-- <div v-text="info.name">{{info.name}}</div> -->
    <component v-if="logins" :is="login" @getphone="getphone" @changepage="changepage"></component>
    <component v-if="types" :is="type" @gettypes="gettypes" @up="up"></component>
    <component v-if="informations" :is="information" @up="up" @getinfo="getinfo" :info="info"></component>
    <component v-if="determines" :is="determine" :info="info" @up="up"></component>
    <component v-if="passs" :is="pass" :info="info"></component>
    <component v-if="detailss" :is="details" @up="up" :info="info" @getkeyurl="getkeyurl"></component>
    <component v-if="mycontracts" :is="mycontract" :info="info" @up="up"></component>
  </div>
</template>

<script>
Vue.component("login", function(resolve) {
  require(["@@/pages/contract/login"], resolve);
});
Vue.component("types", function(resolve) {
  require(["@@/pages/contract/types"], resolve);
});
Vue.component("information", function(resolve) {
  require(["@@/pages/contract/information"], resolve);
});
Vue.component("determine", function(resolve) {
  require(["@@/pages/contract/determine"], resolve);
});
Vue.component("pass", function(resolve) {
  require(["@@/pages/contract/pass"], resolve);
});
Vue.component("cdetails", function(resolve) {
  require(["@@/pages/contract/cdetails"], resolve);
});
Vue.component("mycontract", function(resolve) {
  require(["@@/pages/contract/mycontract"], resolve);
});
export default {
  name: "home",
  components: {},
  data() {
    return {
      login: "login",
      logins: true,
      type: "types",
      types: false,
      information: "information",
      informations: false,
      determines: false,
      determine: "determine",
      passs: false,
      pass: "pass",
      detailss: false,
      details: "cdetails",
      mycontracts: false,
      mycontract: "mycontract",
      phone: "",
      hezuo: "",
      info: {
        lists: [
          {
            link: "",
            num: ""
          }
        ]
      }
    };
  },
  created() {
    this.info.talent_contract = [];
  },
  methods: {
    getphone(phonelg) {
      this.phone = phonelg;
    },
    changepage(pagename) {
      if (pagename == "types" && this.logins) {
        this.types = true;
        this.logins = false;
      } else if (pagename == "mycontract" && this.logins) {
        this.mycontracts = true;
        this.logins = false;
      } else {
        this.passs = true;
        this.logins = false;
      }
    },
    gettypes(typehezuo, pagename) {
      this.info.talent_works = typehezuo;
      this.info.talent_works = typehezuo;
      if (pagename == "information" && this.types) {
        this.types = false;
        this.informations = true;
      }
    },
    getinfo(go, name) {
      if (this.info.talent_contact == "" || this.info.talent_contact == null) {
        this.utils.successMessage("请填写联系人");
        return;
      }
      if (this.info.talent_idcard == "" || this.info.talent_idcard == null) {
        this.utils.successMessage("请填写身份证号码");
        return;
      }
      if (this.info.talent_phone == "" || this.info.talent_phone == null) {
        this.utils.successMessage("请填写联系人电话");
        return;
      }
      if (this.info.talent_address == "" || this.info.talent_address == null) {
        this.utils.successMessage("请填写联系人地址");
        return;
      }
      if (this.info.talent_email == "" || this.info.talent_email == null) {
        this.utils.successMessage("请填写联系人邮箱");
        return;
      }
      if (this.info.talent_nick == "" || this.info.talent_nick == null) {
        this.utils.successMessage("请填写联系人昵称");
        return;
      }
      if (go == "determine" && this.informations) {
        this.determines = true;
        this.informations = false;
      }
    },
    up(uplo) {
      if (uplo == "types" && this.informations) {
        this.types = true;
        this.informations = false;
      }
      if (uplo == "information" && this.determines) {
        this.informations = true;
        this.determines = false;
      }
      if (uplo == "cdetails" && this.determines) {
        this.detailss = true;
        this.determines = false;
      }
      if (uplo == "determine" && this.detailss) {
        this.determines = true;
        this.detailss = false;
      }
      if (uplo == "pass" && this.detailss) {
        this.passs = true;
        this.detailss = false;
      }
      if (uplo == "login" && this.mycontracts) {
        this.logins = true;
        this.mycontracts = false;
      }
      if (uplo == "login" && this.types) {
        this.logins = true;
        this.types = false;
      }
    },
    getkeyurl(keurl) {
      this.info.talent_contract = String(keurl);
      console.log(String(keurl));
      this.updatathis();
    },
    updatathis() {
      let param = {};
      param = this.info;
      this.req
        .post(
          url_api_admin_native_userTalent_uploadTalentInfo,
          this.qs.stringify(param)
        )
        .then(result => {
          this.utils.successMessage(result.info);
          this.info.keyurl =
            global.URL_PROD_API_BASE_DOMAIN + result.download_link;
          this.up("pass");
        })
        .catch(error => {
          this.utils.errorMessage(error);
        });
    }
  }
};
</script>